import { Field, ID, Int, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '@ztechapps/common.contract'
import { HaulerCustomer } from './HaulerCustomer'
import { MilkPickupRouteCustomerRef } from './MilkPickupRouteCustomerRef'

@ObjectType()
export class HaulerRouteDetail {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('hrtd') })
  _id: string

  @Field(() => HaulerCustomer, { nullable: true })
  @Prop({ type: MilkPickupRouteCustomerRef })
  customer?: ReturnType<() => MilkPickupRouteCustomerRef>

  @Field(() => Int, { nullable: true })
  @Prop({ type: Number })
  position?: number
}
